import { g2Factory, getConsoleConfig, Utils, g2Legend, g2Tooltip, g2Size, g2Style, g2Label, Constants } from '@alicloud/console-shared-utils';

/*
 * for Sankey Diagram
 * graph data required (nodes, edges)
 */
var _a = require('d3-sankey'), sankey = _a.sankey, sankeyLeft = _a.sankeyLeft, sankeyRight = _a.sankeyRight, sankeyCenter = _a.sankeyCenter, sankeyJustify = _a.sankeyJustify;
var isString = function (val) { return typeof val === 'string'; };
var isFunction = function (val) { return val && typeof val === 'function'; };
var ALIGN_METHOD = {
    start: sankeyLeft,
    end: sankeyRight,
    center: sankeyCenter,
    justify: sankeyJustify
};
var DEFAULT_OPTIONS = {
    // nodeId: node => node.index,
    value: function (node) { return node.value; },
    source: function (edge) { return edge.source; },
    target: function (edge) { return edge.target; },
    nodeAlign: 'justify',
    nodeWidth: 0.02,
    nodePadding: 0.02
};
function transform(dv, options, customOptions) {
    var topology = customOptions.topology;
    options = Object.assign({}, DEFAULT_OPTIONS, options);
    var nodeAlign = null;
    if (isString(options.nodeAlign)) {
        nodeAlign = ALIGN_METHOD[options.nodeAlign];
    }
    else if (isFunction(options.nodeAlign)) {
        nodeAlign = options.nodeAlign;
    }
    var sankeyProcessor = sankey()
        .links(function (d) { return d.edges; })
        .nodeWidth(options.nodeWidth)
        .nodePadding(options.nodePadding)
        .extent([[0, 0], [1, 1]]);
    if (isFunction(options.nodeId)) {
        sankeyProcessor.nodeId(options.nodeId);
    }
    if (nodeAlign) {
        sankeyProcessor.nodeAlign(nodeAlign);
    }
    sankeyProcessor(dv);
    // post process (x, y), etc.
    dv.nodes.forEach(function (node) {
        var x0 = node.x0, x1 = node.x1, y0 = node.y0, y1 = node.y1;
        /* points
         * 3---2
         * |   |
         * 0---1
         */
        node.x = [x0, x1, x1, x0];
        node.y = [y0, y0, y1, y1];
    });
    if (topology) {
        dv.edges.forEach(function (edge) {
            var source = edge.source, target = edge.target;
            var sx = source.x1;
            var tx = target.x0;
            var sy = source.y0;
            var ty = target.y1;
            edge.x = [sx, sx, tx, tx];
            // const offset = edge.width / 2;
            edge.y = [
                sy + (source.y1 - source.y0) / 2,
                sy + (source.y1 - source.y0) / 2,
                ty + (target.y0 - target.y1) / 2,
                ty + (target.y0 - target.y1) / 2
            ];
        });
    }
    else {
        dv.edges.forEach(function (edge) {
            var source = edge.source, target = edge.target;
            var sx = source.x1;
            var tx = target.x0;
            edge.x = [sx, sx, tx, tx];
            var offset = edge.width / 2;
            edge.y = [edge.y0 + offset, edge.y0 - offset, edge.y1 + offset, edge.y1 - offset];
        });
    }
}

var COMPONENT_NAME = 'ConsoleSankeyChart';
var cfg = {
    getUnifiedProps: function (props) {
        var config = props.config;
        var defaultConfig = getConsoleConfig()[COMPONENT_NAME];
        var newConfig = Utils.merge({}, defaultConfig, config);
        var unionProps = Object.assign({}, props, {
            config: newConfig,
            padding: props.padding || newConfig.padding || 'auto',
        });
        return unionProps;
    },
    // 图表绘制主函数，必选
    drawChart: function (chart, config, data) {
        var nodesData = data.find(function (x) { return x.type === 'node'; }) || {};
        var linksData = data.find(function (x) { return x.type === 'link'; }) || {};
        var adaptData = {
            nodes: nodesData.data || [],
            edges: linksData.data || [],
        };
        var _a = config.direction, direction = _a === void 0 ? 'horizontal' : _a, _b = config.linkType, linkType = _b === void 0 ? 'arc' : _b, _c = config.linkColor, linkColor = _c === void 0 ? '#ECECEC' : _c, _d = config.linkOpacity, linkOpacity = _d === void 0 ? 0.6 : _d, _e = config.nodeAlign, nodeAlign = _e === void 0 ? 'justify' : _e, _f = config.nodeWidth, nodeWidth = _f === void 0 ? 0.02 : _f, _g = config.nodePadding, nodePadding = _g === void 0 ? 0.02 : _g, _h = config.topology, topology = _h === void 0 ? false : _h;
        var d3SankeyConfig = {
            nodeAlign: nodeAlign,
            nodeWidth: nodeWidth,
            nodePadding: nodePadding,
        };
        var customOptions = {
            topology: topology,
        };
        transform(adaptData, d3SankeyConfig, customOptions);
        g2Legend(chart, config, config.legend);
        var tooltip = {
            showTitle: false,
        };
        if (config.tooltip) {
            tooltip = config.tooltip;
        }
        g2Tooltip(chart, config, tooltip);
        chart.axis(false);
        chart.scale({
            x: { sync: true },
            y: { sync: true }
        });
        var position = 'x*y';
        if (direction === 'vertical') {
            position = 'y*x';
        }
        var edgeView = chart.view();
        edgeView.source(adaptData.edges);
        edgeView.edge()
            .position(position)
            .shape(linkType)
            .color(linkColor)
            .opacity(linkOpacity)
            .tooltip('source*target', function (source, target) {
            var name = source.index;
            var value = target.index;
            if (source.name !== undefined && target.name !== undefined) {
                name = source.name;
                value = target.name;
            }
            return {
                name: name,
                value: value,
            };
        });
        g2Size(edgeView, config, config.size);
        g2Style(edgeView, config, config.style);
        g2Label(edgeView, config, config.label);
        // node view
        var nodeView = chart.view();
        var colors = config.colors || Utils.get(this, 'consoleTheme.colors_24') || Constants.COLORS_24;
        nodeView.source(adaptData.nodes);
        nodeView.polygon()
            .position(position) // nodes数据的x、y由layout方法计算得出
            .color('name', colors)
            .style({
            stroke: '#ccc'
        })
            // .label('name', {
            //   useHtml: true,
            //   htmlTemplate: (text, item, index) => {
            //     return `<div>${text}</div>`;
            //   },
            // })
            .tooltip('name', function (name) { return ({
            name: name,
        }); });
        g2Size(nodeView, config, config.size);
        g2Style(nodeView, config, config.style);
        // g2Label(nodeView, config, config.label);
        chart.render();
    },
};
var ConsoleRoseChart = g2Factory(COMPONENT_NAME, cfg);

export default ConsoleRoseChart;
